/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconProfileTrophy = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M13.893 7.293c-.355 1.824-1.754 2.661-2.678 2.7.78-1.724 1.049-4.048 1.139-5.994l.984-.007c.34.176.83 1.888.555 3.301zm-9.109 2.7c-.924-.04-2.321-.877-2.676-2.7-.276-1.413.215-3.125.511-3.293h1.027c.09 1.946.358 4.269 1.138 5.993zm9.398-6.567c-.29-.352-.595-.426-.8-.426h-.994c.013-.595.015-1.132.015-1.561 0-.498-.404-.939-.903-.939h-7c-.498 0-.902.453-.902.951 0 .426.001.959.014 1.549h-.993c-.206 0-.51.074-.8.426-.639.775-.963 2.672-.693 4.059C1.571 9.768 3.379 11 4.854 11h.501c.533.745 1.238 1.244 2.145 1.387V14.5h-3a.5.5 0 0 0 0 1h7a.499.499 0 1 0 0-1h-3v-2.113c.907-.143 1.611-.642 2.145-1.387h.501c1.476 0 3.284-1.232 3.728-3.515.27-1.387-.053-3.284-.692-4.059z"
    />
  </svg>
);

IconProfileTrophy.displayName = 'IconProfileTrophy';

IconProfileTrophy.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconProfileTrophy);
IconProfileTrophy.displayName = 'IconProfileTrophy';
